
export function getServerSideData<T>(key: string): T | undefined {
    // @ts-ignore
    if (window.serverSide) {
        // @ts-ignore
        return window.serverSide[key];
    }
}